import React from 'react';
import dayjs, { Dayjs } from 'dayjs';

import { IconChevronLeft, IconChevronRight } from '@pentabd/icons';
import Text from '../text/Text';
import { SELECT_VIEW } from './constants';

interface Props {
  range?: boolean;
  displayDate: Dayjs;
  setDisplayedDate: (data: Dayjs) => void;
  setActiveSelectView: (data: string) => void;
  onClickPrevious: ({ month, year }: { month: number; year: number }) => void;
  onClickNext: ({ month, year }: { month: number; year: number }) => void;
}

function CalenderHeader({
  displayDate,
  setDisplayedDate,
  setActiveSelectView,
  onClickPrevious,
  onClickNext,
}: Props) {
  const previousMonth = () => {
    const data = dayjs(displayDate).subtract(1, 'months');
    setDisplayedDate(data);
    onClickPrevious &&
      onClickPrevious({ month: data.month() + 1, year: data.year() });
  };
  const nextMonth = () => {
    const data = dayjs(displayDate).add(1, 'months');
    setDisplayedDate(data);

    onClickNext && onClickNext({ month: data.month() + 1, year: data.year() });
  };

  return (
    <div className="d-flex justify-content-between align-items-center p-10">
      <div className="pointer" onClick={previousMonth}>
        <IconChevronLeft size={20} />
      </div>
      <div className="d-flex gap-6">
        <div
          className="pointer"
          onClick={() => setActiveSelectView(SELECT_VIEW.MONTH)}
        >
          <Text size="md" color="dark" weight="semibold">
            {displayDate?.format('MMMM')}
          </Text>
        </div>
        <div
          className="pointer"
          onClick={() => setActiveSelectView(SELECT_VIEW.YEAR)}
        >
          <Text size="md" color="dark" weight="semibold">
            {displayDate?.format('YYYY')}
          </Text>
        </div>
      </div>
      <div className="pointer" onClick={nextMonth}>
        <IconChevronRight size={20} />
      </div>
    </div>
  );
}

export default CalenderHeader;
